import styled, { css } from "styled-components";
import { fontSize11, grey10, textColorInverted, white, lineHeightTight, spacing16, spacing4, spacing24, textColorPrimary, fontWeightNormal, grey90, setAppearanceConstantLocal, grey35, grey40, grey3, grey60, whiteTransparency20, whiteTransparency70, whiteTransparency80, borderColorSecondary, textColorSecondary, textColorTertiary } from "@churchofjesuschrist/eden-style-constants";
import { adjustHexAlpha } from "@churchofjesuschrist/eden-utilities";
const [tagBorderColorDef, tagBorderColor] = setAppearanceConstantLocal("tag-border-color", {
  light: textColorPrimary,
  dark: white,
  prefix: "eden"
});
const [tagBackgroundColorDef, tagBackgroundColor] = setAppearanceConstantLocal("tag-background", {
  light: grey3,
  dark: grey60,
  prefix: "eden"
});
const [tagSelectedBackgroundDef, tagSelectedBackground] = setAppearanceConstantLocal("tag-selected-background", {
  light: grey90,
  dark: white,
  prefix: "eden"
});
const [tagSelectedHoverBackgroundDef, tagSelectedHoverBackground] = setAppearanceConstantLocal("tag-selected-hover-background", {
  light: grey40,
  dark: whiteTransparency20,
  prefix: "eden"
});
const [tagSelectedHoverBorderDef, tagSelectedHoverBorder] = setAppearanceConstantLocal("tag-selected-hover-border", {
  light: textColorPrimary,
  dark: white,
  prefix: "eden"
});
const [tagSelectedActiveBackgroundDef, tagSelectedActiveBackground] = setAppearanceConstantLocal("tag-selected-active-background", {
  light: grey10,
  dark: grey40,
  prefix: "eden"
});
const [tagActiveBackgroundDef, tagActiveBackground] = setAppearanceConstantLocal("tag-active-background", {
  light: grey10,
  dark: grey40,
  prefix: "eden"
});
const [tagDisabledBackgroundDef, tagDisabledBackground] = setAppearanceConstantLocal("tag-disabled-background", {
  light: adjustHexAlpha(grey90, 0.08),
  dark: grey40,
  prefix: "eden"
});
const [tagDisabledSelectedBackgroundDef, tagDisabledSelectedBackground] = setAppearanceConstantLocal("tag-disabled-selected-background", {
  light: grey10,
  dark: grey35,
  prefix: "eden"
});
const [tagDisabledSelectedBorderDef, tagDisabledSelectedBorder] = setAppearanceConstantLocal("tag-disabled-selected-border", {
  light: grey10,
  dark: grey35,
  prefix: "eden"
});
const [tagHoverBorderDef, tagHoverBorder] = setAppearanceConstantLocal("tag-hover-border", {
  light: "inherit",
  dark: whiteTransparency80,
  prefix: "eden"
});
const getDefaultState = ({
  selected
}) => {
  if (selected) {
    return `
        color: ${textColorInverted};
        background: ${tagSelectedBackground()};`;
  } else {
    return "";
  }
};
const getHoverState = ({
  selected
}) => {
  if (selected) {
    return `background: ${tagSelectedHoverBackground()}; color: ${textColorInverted}; border-color: ${tagSelectedHoverBorder()};`;
  } else {
    return `background: ${whiteTransparency70}; color: ${textColorPrimary}; border-color: ${tagHoverBorder()};`;
  }
};
const getActiveState = ({
  selected
}) => {
  if (selected) {
    return `background: ${tagSelectedActiveBackground()}; color:${textColorPrimary}`;
  }
  {
    return `background: ${tagActiveBackground()}; color:${textColorPrimary}`;
  }
};
export const tagStyles = css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " background:", ";border:1px solid ", ";color:", ";font-size:", ";padding:0 ", ";border-radius:0.9375rem;letter-spacing:0.01em;min-height:", ";display:inline-flex;align-items:center;font-weight:", ";max-width:18rem;line-height:", ";", ";&:hover{", ";}&:active{", ";}&:disabled{pointer-events:none;color:", ";border-color:", ";background:", ";}"], tagBorderColorDef, tagBackgroundColorDef, tagHoverBorderDef, tagSelectedBackgroundDef, tagSelectedHoverBackgroundDef, tagSelectedActiveBackgroundDef, tagActiveBackgroundDef, tagDisabledBackgroundDef, tagDisabledSelectedBackgroundDef, tagSelectedHoverBorderDef, tagDisabledSelectedBorderDef, tagBackgroundColor, tagBorderColor, textColorPrimary, fontSize11, spacing16, spacing24, fontWeightNormal, lineHeightTight, getDefaultState, getHoverState, getActiveState, ({
  selected
}) => selected ? textColorSecondary : textColorTertiary, ({
  selected
}) => selected ? tagDisabledSelectedBorder : borderColorSecondary, ({
  selected
}) => selected ? tagDisabledSelectedBackground : tagDisabledBackground);
export const Content = styled.span.withConfig({
  componentId: "sc-kb0k5s-0"
})(["min-height:calc(", " - 0.125rem);padding:", " 0;overflow-wrap:break-word;min-width:0;&:empty{display:none;}"], spacing24, spacing4);